import type { TimerButtonProps } from './TimerButton.types';

import React, { useState, useMemo, useEffect } from 'react';
import classNames from 'classnames';
import * as constants from './TimerButton.constants';
import './_timer-button.scss';

export const TimerButton = ({ id, duration, warning = constants.WARNING_SECONDS, onTimeExpired, unlimited = false }: TimerButtonProps) => {
  const [timeRemaining, setTimeRemaining] = useState<number>(duration > 0 ? duration : 0);
  const [isVisibleContent, setIsVisibleContent] = useState<boolean>(true);

  useEffect(() => {
    if (unlimited) return;
    if (timeRemaining > 0) {
      const intervalId = setInterval(() => {
        setTimeRemaining((timeRemaining) => timeRemaining - 1);
      }, 1000);

      return () => clearInterval(intervalId);
    }
  }, [timeRemaining, unlimited]);

  useEffect(() => {
    if (!unlimited) {
      setTimeRemaining(duration);
    } else {
      setTimeRemaining(Infinity);
    }
  }, [id, duration, unlimited]);

  const buttonContent = useMemo(() => {
    if (!isVisibleContent) return null;

    if (unlimited) {
      return;
    }

    const minutes = Math.floor(timeRemaining / 60);
    const seconds = timeRemaining % 60;
    return timeRemaining > 0
      ? `Time Remaining ${minutes}:${seconds < 10 ? '0' : ''}${seconds}`
      : 'Time Expired';
  }, [isVisibleContent, timeRemaining, unlimited]);

  useEffect(() => {
    if (!unlimited && timeRemaining <= 0) {
      onTimeExpired?.();
    }
  }, [timeRemaining, unlimited]);

  const handleButtonClick = () => setIsVisibleContent(!isVisibleContent);
  if (unlimited) return null;
  return (
    <button
      className={classNames({ 'timer-button': true, 'timer-button--warning': timeRemaining <= warning })}
      onClick={handleButtonClick}
    >
      {buttonContent}
    </button>
  );
};
